export default __webpack_public_path__ + "static/media/009-intersection-3.1cb6feb6.png";